import { HttpClient } from "../utils/httpClient";

const PATH = {
  profile: "/user/user/profile",
  updatePassword: "/user/user/update-password",
  updateProfile: "/user/user/update-profile",
  getAll: "/admin/user",
  create: "/admin/user",
  update: "/admin/user",
  delete: "/admin/user",
  updateAccess: "/admin/user/access",
  createmany: "/admin/user/create-many",
};

const Profile = (start, callback, error, next) => {
  start();
  return HttpClient.get(PATH.profile).then(callback).catch(error).finally(next);
};

const UpdatePassword = (payload, start, callback, error, next) => {
  start();
  return HttpClient.put(PATH.updatePassword, payload)
    .then(callback)
    .catch(error)
    .finally(next);
};

const UpdateProfile = (payload, start, callback, error, next) => {
  start();
  return HttpClient.put(PATH.updateProfile, payload)
    .then(callback)
    .catch(error)
    .finally(next);
};

const GetAll = (params = {}, start, callback, error, next) => {
  start();
  return HttpClient.get(PATH.getAll, { params })
    .then(callback)
    .catch(error)
    .finally(next);
};

const Create = (payload, start, callback, error, next) => {
  start();
  return HttpClient.post(PATH.create, payload)
    .then(callback)
    .catch(error)
    .finally(next);
};

const Update = (id, payload, start, callback, error, next) => {
  start();
  return HttpClient.patch(`${PATH.update}/${id}`, payload)
    .then(callback)
    .catch(error)
    .finally(next);
};

const Delete = (id, start, callback, error, next) => {
  start();
  return HttpClient.delete(`${PATH.update}/${id}`)
    .then(callback)
    .catch(error)
    .finally(next);
};

const UpdateAccess = (id, payload, start, callback, error, next) => {
  start();
  return HttpClient.put(`${PATH.updateAccess}/${id}`, payload)
    .then(callback)
    .catch(error)
    .finally(next);
};

const CreateMany = (payload, start, callback, error, next) => {
  start();
  return HttpClient.post(`${PATH.createmany}`, payload)
    .then(callback)
    .catch(error)
    .finally(next);
};

export const UserService = {
  Profile,
  UpdatePassword,
  UpdateProfile,
};

export const AdminUserService = {
  GetAll,
  Create,
  Update,
  Delete,
  UpdateAccess,
  CreateMany,
};
